import { Popover } from '@mui/material'
import EmojiPicker from 'emoji-picker-react'

export default function EmojiReactionPopover({ open, anchorEl, onClose, onEmojiSelect }) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      slotProps={{ paper: { sx: { overflow: 'hidden', borderRadius: 2 } } }}
    >
      <EmojiPicker
        onEmojiClick={(data) => {
          onEmojiSelect?.(data.emoji)
          onClose?.()
        }}
        width={320}
        height={400}
        previewConfig={{ showPreview: false }}
        skinTonesDisabled
      />
    </Popover>
  )
}
